import { render } from "./ProposalCreate.vue?vue&type=template&id=7ef08804&scoped=true"
import script from "./ProposalCreate.vue?vue&type=script&lang=js"
export * from "./ProposalCreate.vue?vue&type=script&lang=js"

import "./ProposalCreate.vue?vue&type=style&index=0&id=7ef08804&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef08804"]])

export default __exports__